"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKitTransaction = exports.createWalletConnectionManager = exports.WalletAdapterManager = exports.createLocalStorageUtility = exports.getAdaptersByReadyState = exports.sortWalletAdapters = void 0;
// Only export the shared types - no implementations that depend on other packages
__exportStar(require("./types/index"), exports);
// Export utilities that don't create circular dependencies
__exportStar(require("./utils/environment"), exports);
// Export specific utility functions that are used by other packages
var adapter_utils_1 = require("./utils/adapter-utils");
Object.defineProperty(exports, "sortWalletAdapters", { enumerable: true, get: function () { return adapter_utils_1.sortWalletAdapters; } });
Object.defineProperty(exports, "getAdaptersByReadyState", { enumerable: true, get: function () { return adapter_utils_1.getAdaptersByReadyState; } });
var storage_1 = require("./utils/storage");
Object.defineProperty(exports, "createLocalStorageUtility", { enumerable: true, get: function () { return storage_1.createLocalStorageUtility; } });
// Export Kit integration utilities
__exportStar(require("./kit-integration"), exports);
__exportStar(require("./chain-utils"), exports);
// Export WalletAdapterManager and createWalletConnectionManager for vanilla TypeScript usage
var manager_1 = require("./core/manager");
Object.defineProperty(exports, "WalletAdapterManager", { enumerable: true, get: function () { return manager_1.WalletAdapterManager; } });
Object.defineProperty(exports, "createWalletConnectionManager", { enumerable: true, get: function () { return manager_1.createWalletConnectionManager; } });
// Re-export createKitTransaction utility from core for convenience
var solana_headless_core_1 = require("@hermis/solana-headless-core");
Object.defineProperty(exports, "createKitTransaction", { enumerable: true, get: function () { return solana_headless_core_1.createKitTransaction; } });
